module.exports = __webpack_public_path__ + "assets/doc.d0ff3e18.svg";